module.exports = __webpack_public_path__ + "static/media/Teddiursa_gaussian2.13ffeb34.png";